'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _colors = require('HubStyleTokens/colors');

var _FormattedMessage = require('I18n/components/FormattedMessage');

var _FormattedMessage2 = _interopRequireDefault(_FormattedMessage);

var _FormattedJSXMessage = require('I18n/components/FormattedJSXMessage');

var _FormattedJSXMessage2 = _interopRequireDefault(_FormattedJSXMessage);

var _UIButton = require('UIComponents/button/UIButton');

var _UIButton2 = _interopRequireDefault(_UIButton);

var _UIIcon = require('UIComponents/icon/UIIcon');

var _UIIcon2 = _interopRequireDefault(_UIIcon);

var _UITile = require('UIComponents/tile/UITile');

var _UITile2 = _interopRequireDefault(_UITile);

var _ImmutableMerchandiseIdMap = require('self-service-api/constants/ImmutableMerchandiseIdMap');

var _ImmutableMerchandiseIdMap2 = _interopRequireDefault(_ImmutableMerchandiseIdMap);

var _UITooltip = require('UIComponents/tooltip/UITooltip');

var _UITooltip2 = _interopRequireDefault(_UITooltip);

var _getFeatureDescriptionKey = require('self-service-api/core/utilities/getFeatureDescriptionKey');

var _getFeatureDescriptionKey2 = _interopRequireDefault(_getFeatureDescriptionKey);

var _MerchandiseIds = require('self-service-api/constants/MerchandiseIds');

var _Hubs = require('self-service-api/constants/Hubs');

var Hubs = _interopRequireWildcard(_Hubs);

var _reactRouterDom = require('react-router-dom');

var _UILink = require('UIComponents/link/UILink');

var _UILink2 = _interopRequireDefault(_UILink);

var _Breakpoints = require('pricing-pages-unified-ui/constants/Breakpoints');

var _ProductsAndPlansNavIds = require('pricing-pages-unified-ui/constants/ProductsAndPlansNavIds');

var _urls = require('pricing-pages-unified-ui/utils/urls');

var _publicPageUrls = require('pricing-pages-unified-ui/utils/publicPageUrls');

var _UIBadge = require('UIComponents/badge/UIBadge');

var _UIBadge2 = _interopRequireDefault(_UIBadge);

var _stringUtils = require('pricing-pages-unified-ui/utils/stringUtils');

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TileFeatureListContainer = _styledComponents2.default.div.withConfig({
  displayName: 'FeaturesSection__TileFeatureListContainer'
})(['padding:45px 25px 15px;']);

var TileHeader = _styledComponents2.default.div.withConfig({
  displayName: 'FeaturesSection__TileHeader'
})(['font-size:15px;font-weight:700;text-transform:uppercase;margin-bottom:27px;']);

var TileViewMoreContainer = _styledComponents2.default.div.withConfig({
  displayName: 'FeaturesSection__TileViewMoreContainer'
})(['width:100%;padding:10px 25px;border-top:1px solid ', ';font-size:14px;text-align:center;'], _colors.KOALA);

var FeatureText = (0, _styledComponents2.default)(_FormattedMessage2.default).withConfig({
  displayName: 'FeaturesSection__FeatureText'
})(['font-size:14px;']);

var FeatureTile = (0, _styledComponents2.default)(function (_ref) {
  var modalViewClassName = _ref.modalViewClassName,
      className = _ref.className,
      header = _ref.header,
      features = _ref.features,
      hubType = _ref.hubType,
      merchandiseId = _ref.merchandiseId,
      onViewMore = _ref.onViewMore;
  return _react2.default.createElement(
    _UITile2.default,
    { className: className },
    _react2.default.createElement(
      TileFeatureListContainer,
      null,
      _react2.default.createElement(
        TileHeader,
        null,
        header
      ),
      Object.keys(features).slice(0, 5).map(function (key) {
        return _react2.default.createElement(
          'div',
          { key: key, className: 'm-bottom-4 flex align-start' },
          _react2.default.createElement(_UIIcon2.default, { name: 'success', className: 'm-right-3' }),
          _react2.default.createElement(
            _UITooltip2.default,
            {
              placement: 'right',
              title: _react2.default.createElement(_FormattedMessage2.default, {
                message: (0, _getFeatureDescriptionKey2.default)(key, hubType)
              })
            },
            _react2.default.createElement(
              'div',
              { style: { display: 'inline-block' } },
              _react2.default.createElement(FeatureText, { message: 'pricing-pages.features.' + key + '.name' }),
              features[key].isNew && (0, _stringUtils.hasStringTranslation)('pricingPage.new') && _react2.default.createElement(
                _UIBadge2.default,
                { use: 'new', className: 'm-left-1' },
                _react2.default.createElement(_FormattedMessage2.default, { message: 'pricingPage.new' })
              )
            )
          )
        );
      })
    ),
    _react2.default.createElement(
      'div',
      { className: 'flex flex-grow-1 align-end' },
      _react2.default.createElement(
        TileViewMoreContainer,
        null,
        _react2.default.createElement(
          _UIButton2.default,
          {
            className: modalViewClassName,
            use: 'link',
            onClick: onViewMore(header, features, hubType, merchandiseId)
          },
          _react2.default.createElement(_FormattedMessage2.default, {
            className: modalViewClassName,
            message: 'pricingPage.pages.crm.viewMore'
          })
        )
      )
    )
  );
}).withConfig({
  displayName: 'FeaturesSection__FeatureTile'
})(['display:flex;flex-direction:column;margin-top:0 !important;flex:1;@media (min-width:', 'px){&:first-child{margin-right:10px;}&:last-child{margin-left:10px;}}@media (max-width:', 'px){&:first-child{margin-bottom:10px;}&:last-child{margin-top:10px;}}'], _Breakpoints.FEATURES_SECTION, _Breakpoints.FEATURES_SECTION - 1);

var AdvancedCrmCta = _styledComponents2.default.div.withConfig({
  displayName: 'FeaturesSection__AdvancedCrmCta'
})(['background-color:', ';border-radius:3px;max-width:816px;text-align:center;padding:25px;margin:16px 0;display:flex;justify-content:center;'], _colors.GYPSUM);

var FeatureRow = _styledComponents2.default.div.withConfig({
  displayName: 'FeaturesSection__FeatureRow'
})(['display:flex;justify-content:center;@media (max-width:', 'px){flex-direction:column;}'], _Breakpoints.FEATURES_SECTION - 1);

var FeaturesSection = (0, _styledComponents2.default)(function (_ref2) {
  var className = _ref2.className,
      onViewMore = _ref2.onViewMore,
      history = _ref2.history;
  return _react2.default.createElement(
    'div',
    { className: className },
    _react2.default.createElement(
      FeatureRow,
      null,
      _react2.default.createElement(FeatureTile, {
        modalViewClassName: (0, _publicPageUrls.getGAClassName)('crm-pricing-crmfeatures'),
        header: _react2.default.createElement(_FormattedMessage2.default, { message: 'pricingPage.pages.crm.freeCrmTools' }),
        hubType: Hubs.HUB_SALES,
        features: _ImmutableMerchandiseIdMap2.default[_MerchandiseIds.PRODUCT_CRM].features,
        onViewMore: onViewMore,
        merchandiseId: _MerchandiseIds.PRODUCT_CRM
      }),
      _react2.default.createElement(FeatureTile, {
        modalViewClassName: (0, _publicPageUrls.getGAClassName)('crm-pricing-marketingfeatures'),
        header: _react2.default.createElement(_FormattedMessage2.default, { message: 'pricingPage.pages.crm.freeMarketingTools' }),
        features: _ImmutableMerchandiseIdMap2.default[_MerchandiseIds.PRODUCT_MARKETING_FREE].features,
        hubType: Hubs.HUB_MARKETING,
        onViewMore: onViewMore,
        merchandiseId: _MerchandiseIds.PRODUCT_MARKETING_FREE
      })
    ),
    _react2.default.createElement(
      AdvancedCrmCta,
      null,
      _react2.default.createElement(
        'div',
        { style: { maxWidth: '550px' } },
        _react2.default.createElement(
          'div',
          null,
          _react2.default.createElement(
            'b',
            null,
            _react2.default.createElement(_FormattedMessage2.default, { message: 'pricingPage.pages.crm.interested' })
          )
        ),
        _react2.default.createElement(_FormattedJSXMessage2.default, {
          options: {
            onClick: function onClick() {
              history.push((0, _urls.getProductTabUrl)(_ProductsAndPlansNavIds.SALES));
            },
            gaClassName: (0, _publicPageUrls.getGAClassName)('crm-pricing-salesplans')
          },
          elements: { UILink: _UILink2.default },
          message: 'pricingPage.pages.crm.learn_jsx'
        })
      )
    ),
    _react2.default.createElement(
      FeatureRow,
      null,
      _react2.default.createElement(FeatureTile, {
        modalViewClassName: (0, _publicPageUrls.getGAClassName)('crm-pricing-salesfeatures'),
        header: _react2.default.createElement(_FormattedMessage2.default, { message: 'pricingPage.pages.crm.freeSalesTools' }),
        features: _ImmutableMerchandiseIdMap2.default[_MerchandiseIds.PRODUCT_SALES_FREE].features,
        hubType: Hubs.HUB_SALES,
        onViewMore: onViewMore,
        merchandiseId: _MerchandiseIds.PRODUCT_SALES_FREE
      }),
      _react2.default.createElement(FeatureTile, {
        modalViewClassName: (0, _publicPageUrls.getGAClassName)('crm-pricing-servicefeatures'),
        header: _react2.default.createElement(_FormattedMessage2.default, { message: 'pricingPage.pages.crm.freeServiceTools' }),
        features: _ImmutableMerchandiseIdMap2.default[_MerchandiseIds.PRODUCT_SERVICE_FREE].features,
        hubType: Hubs.HUB_SERVICE,
        onViewMore: onViewMore,
        merchandiseId: _MerchandiseIds.PRODUCT_SERVICE_FREE
      })
    )
  );
}).withConfig({
  displayName: 'FeaturesSection'
})(['width:100%;max-width:840px;padding:0 20px;z-index:2;']);

exports.default = (0, _reactRouterDom.withRouter)(FeaturesSection);
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./js/components/free-tools-page/FeaturesSection.js
// module id = 643
// module chunks = 3 4